import React from "react"
import {ShoppingBagBadge} from "./components"

export type ClubShoppingBagBadgeProps = {
    children: React.ReactNode
    items: number | string
}

const ClubShoppingBagBadge = ({children, items}: ClubShoppingBagBadgeProps) => (
    <ShoppingBagBadge badgeContent={items} invisible={items === "" || items === 0}>
        {children}
    </ShoppingBagBadge>
)

export default ClubShoppingBagBadge
